import React from 'react'
import { useHistory } from 'react-router-dom'

import Tooltip2 from 'components/common/Tooltip2.0'
import { MenuIcon } from 'components/Controls/styles'
import { classStore } from 'helpers/room'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { logger } from 'utils/logger'

import { EndCallButtonStyle } from './styles'

const EndCallButton = () => {
    const { room } = useVideoContext()
    const history = useHistory()

    const endCall = () => {
        classStore.set('off')
        localStorage.setItem('refresh', 'false')
        const arr = ['']
        localStorage.setItem('canvaslist', JSON.stringify(arr))
        room.disconnect()
        logger.info('user has ended the call')
        history && history.push('/feedback')
    }

    console.count('EndCallButton Component')

    return (
        <Tooltip2 content="end call" onClick={endCall} placement="top">
            <EndCallButtonStyle>
                <MenuIcon src="/assets/revamp/call-end.svg" alt="end-call" />
            </EndCallButtonStyle>
        </Tooltip2>
    )
}

export { EndCallButton }
